export enum EActiveInactiveStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
